var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcuador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "artwork"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M19.9048 0.5H2.09524C0.93807 0.5 0 1.45513 0 2.63333V14.3667C0 15.5449 0.93807 16.5 2.09524 16.5H19.9048C21.0619 16.5 22 15.5449 22 14.3667V2.63333C22 1.45513 21.0619 0.5 19.9048 0.5Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5H22V16.5H0V12.5Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H22V8.5H0V0.5Z",
    fill: "#FFDA2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28564 4.76758H9.4285L10.9999 5.83424L12.5714 4.76758H15.7142L12.5714 5.83424L11.5237 6.90091H10.4761L9.4285 5.83424L6.28564 4.76758Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_5",
    d: "M10.9999 11.1671C11.8678 11.1671 12.5713 10.2119 12.5713 9.03372C12.5713 7.85552 11.8678 6.90039 10.9999 6.90039C10.132 6.90039 9.42847 7.85552 9.42847 9.03372C9.42847 10.2119 10.132 11.1671 10.9999 11.1671Z",
    fill: "#3ECBF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38087 7.9668V10.1001L10.4761 11.1668H11.5237L13.619 10.1001V7.9668L14.6666 10.1001L13.619 11.1668L11.5237 12.2335H10.4761L8.38087 11.1668L7.33325 10.1001L8.38087 7.9668Z",
    fill: "#FFDA2C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4315_2092"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcuador);
export default __webpack_public_path__ + "static/media/ecuador.f60413447008ec7636408228df88f902.svg";
export { ForwardRef as ReactComponent };